/* eslint-disable @typescript-eslint/no-namespace */
import * as React from "react"
import type { GQLParams, ExtraInputs, AdvisorFieldsType, IntelligenceKeys } from "@oysterhr/advisor"
import { Maybe } from "@oysterhr/schema"
import { ClickableTooltip } from "~/app/components/ClickableTooltip"

/* TODO: is there a way to efficiently reuse
AdvisorFieldsType, IntelligenceKeys or IntelligenceKeys in Pearl context type? */

type Options<T extends AdvisorFieldsType> = {
  gqlParams?: GQLParams
  extraInputs?: T extends IntelligenceKeys ? ExtraInputs[T] : Record<string, unknown>
}

export namespace AdvisorActions {
  export type OnFocusHandler = <T extends AdvisorFieldsType>(
    fieldName: Maybe<T> | undefined,
    options?: Options<T>,
  ) => () => void

  export type CreateTooltipHandler = <T extends AdvisorFieldsType>(
    name?: T,
    options?: Options<T>,
  ) => (() => void) | undefined

  export type CreateTooltip = <T extends AdvisorFieldsType>(
    name?: T,
    options?: Options<T>,
  ) => JSX.Element | null
}

interface ContextualHelperIconButtonProps {
  onClick: (() => void) | undefined
  className?: string
}

/**
 * We need this component around <ClickableTooltip/> to account for cases where `createTooltipHandler` returns undefined.
 * When tooltip handler is undefined, it means the icons with tooltips should not be rendered
 * We will pass the return value of `createTooltipHandler` to this component's onClick function, like
 * <ContextualHelperIconButton onClick={createTooltipHandler('exampleFieldName')} />
 */
export const ContextualHelperIconButton = ({
  onClick,
  className,
}: ContextualHelperIconButtonProps): React.ReactElement | null => {
  if (onClick) {
    return <ClickableTooltip onClick={onClick} iconClassnames={className} />
  }

  return null
}
